export enum Gender {
  Male = 'Male',
  Female = 'Female',
  Neutral = 'Neutral',
}

export const colors: Record<Gender, string> = {
  [Gender.Female]: '#ff5a8b',
  [Gender.Male]: '#1b9cfd',
  [Gender.Neutral]: '#f3ad02',
}
